<div class="snackbar"
  [ngClass]="gravity">
  @if (!this.isFailure) {
    <div>{{title}}</div>
  }
  <div>{{message}}</div>
</div>
